module.exports = __webpack_public_path__ + "img/2.1.4ee9bd9e.png";